import {
  getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationFetcher,
  getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

/**
 * 企業契約期間を更新する mutation hook
 *
 * PUT /api/v1/:three_letter_code/partner_admins/clients/:client_id/client_contracts/:id
 *
 * @param threeLetterCode - パートナーコード（getThreeLetterCode() で取得した値）
 * @param clientId - 利用企業 ID（Screen 層でパース・検証済みの数値）
 * @param termId - 企業契約期間 ID（Screen 層でパース・検証済みの数値）
 * @param options - コールバックオプション
 */
export const usePutClientContractTerm = (
  threeLetterCode: string,
  clientId: number,
  termId: number,
  options?: {
    onSuccess?: (
      data: PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200
    ) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationKey(
      threeLetterCode,
      clientId,
      termId
    ),
    getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdMutationFetcher(
      threeLetterCode,
      clientId,
      termId
    ),
    options
  );
};
